var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"no-results d-flex flex-column justify-content-center align-items-center w-100"},[_c('img',{staticClass:"no-results-img my-2",attrs:{"loading":"lazy","src":require("@/assets/img/logo.svg"),"alt":"Logo"}}),_c('span',{staticClass:"my-2"},[_vm._v(_vm._s(_vm.$t('noResults')))])])
}
var staticRenderFns = []

export { render, staticRenderFns }